import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { resolveInterceptors } from "../requestor/interceptors-manager";
import { fill } from "./helpers/path-filler";
import { handleAuthorizationDetail } from "./auth";
export function makeDataMethodPayloadForRequest(apiOptions, pathKeys, options, requestData, config) {
  var interceptors = {
    request: apiOptions.interceptor && apiOptions.interceptor.request && [apiOptions.interceptor.request] || [],
    response: apiOptions.interceptor && apiOptions.interceptor.response && [apiOptions.interceptor.response] || []
  };
  var needAuth = this.auth.alwaysAuth || apiOptions.needAuth;

  if (needAuth && this.auth.getter) {
    interceptors.request.push(handleAuthorizationDetail(this.auth.getter));
  }

  return {
    config: _objectSpread({
      method: apiOptions.method,
      url: fill(apiOptions.path, pathKeys),
      data: requestData,
      params: options
    }, config || {}),
    interceptors: interceptors
  };
}
;
export var makeMethod = function makeMethod(apiOptions) {
  return /*#__PURE__*/function () {
    var _apiMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathKeys, options, requestConfig) {
      var _makeDataMethodPayloa, config, interceptors, resolvedRequestConfig, method, url, response;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _makeDataMethodPayloa = makeDataMethodPayloadForRequest.call(this, apiOptions, pathKeys, options, null, requestConfig), config = _makeDataMethodPayloa.config, interceptors = _makeDataMethodPayloa.interceptors;
              _context.next = 3;
              return resolveInterceptors(interceptors.request, config);

            case 3:
              resolvedRequestConfig = _context.sent;
              // Remove duplicated option from config to prevent merge issue inside axios
              method = config.method, url = config.url;
              delete resolvedRequestConfig.method;
              delete resolvedRequestConfig.url;
              _context.next = 9;
              return this.requestor[method](url, resolvedRequestConfig);

            case 9:
              response = _context.sent;
              return _context.abrupt("return", resolveInterceptors(interceptors.response, response));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function apiMethod(_x, _x2, _x3) {
      return _apiMethod.apply(this, arguments);
    }

    return apiMethod;
  }();
};
export var makeDataMethod = function makeDataMethod(apiOptions) {
  return /*#__PURE__*/function () {
    var _apiDataMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pathKeys, options, requestData, requestConfig) {
      var _makeDataMethodPayloa2, config, interceptors, resolvedRequestConfig, method, url, data, response;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _makeDataMethodPayloa2 = makeDataMethodPayloadForRequest.call(this, apiOptions, pathKeys, options, requestData, requestConfig), config = _makeDataMethodPayloa2.config, interceptors = _makeDataMethodPayloa2.interceptors;
              _context2.next = 3;
              return resolveInterceptors(interceptors.request, config);

            case 3:
              resolvedRequestConfig = _context2.sent;
              // Remove duplicated option from config to prevent merge issue inside axios
              method = config.method, url = config.url, data = config.data;
              delete resolvedRequestConfig.method;
              delete resolvedRequestConfig.url;
              delete resolvedRequestConfig.data;
              _context2.next = 10;
              return this.requestor[method](url, data, resolvedRequestConfig);

            case 10:
              response = _context2.sent;
              return _context2.abrupt("return", resolveInterceptors(interceptors.response, response));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function apiDataMethod(_x4, _x5, _x6, _x7) {
      return _apiDataMethod.apply(this, arguments);
    }

    return apiDataMethod;
  }();
};